import { render, staticRenderFns } from "./DropdownTaxWithheld.vue?vue&type=template&id=63c2f54b&scoped=true&"
import script from "./DropdownTaxWithheld.vue?vue&type=script&lang=ts&"
export * from "./DropdownTaxWithheld.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownTaxWithheld.vue?vue&type=style&index=0&id=63c2f54b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c2f54b",
  null
  
)

export default component.exports